import React from 'react';
import { price } from '../../utils/format';

const GettingStartedDeliveryOption = ({ option }) => (
  <div className="getting-started_packages-item -info">
    <div className="getting-started_packages-item-title">{option.name}</div>
    {Boolean(option.price) && (
      <div className="getting-started_packages-item-price">+ {price(option.price)}</div>
    )}
    <div className="getting-started_packages-item-info">{option.description}</div>
  </div>
);

export default GettingStartedDeliveryOption;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedDelivery/GettingStartedDeliveryOption.js